import axios from 'axios';

import { apiClient } from '@flipster/apis/axios';

import { ZendeskArticles } from './types';
import { zendesk } from './url';

export const getZendeskNoticesApi = () => axios.get<ZendeskArticles>(zendesk.getZendeskExternalUrl('NoticesApi'));
export const getZendeskEmergenciesApi = (isSpotOnly?: boolean) =>
  axios.get<ZendeskArticles>(zendesk.getZendeskExternalUrl(isSpotOnly ? 'EmergenciesApiVara' : 'EmergenciesApi'));

export const getZendeskJwtApi = (type: 'CHAT' | 'SSO') =>
  apiClient.get<{ jwt: string }>('/v1/user/jwt/zendesk', { params: { type } });
